
export const formatVolunteerFormData = (volunteerOpportunity, volunteerFormData) => {
    return Object.keys(volunteerFormData)
        .filter(k => k.includes('question|'))
        .map(k => {
            let id = parseInt(k.split('|')[1], 10);
            let label = volunteerOpportunity.questions.filter(q => q.id === id)[0].label;
            let values = Array.isArray(volunteerFormData[`question|${id}`])
                ? volunteerFormData[`question|${id}`]
                : [volunteerFormData[`question|${id}`]];

            return Object.assign(
                {},
                {
                    id,
                    label,
                    values
                }
            );
        });
};

export const replaceLocale = state => {
    if (state.volunteer.postalCode) {
        return state.volunteer.postalCode;
    }
    if ((state.widget.endUserLocation || {}).regionName) {
        return state.widget.endUserLocation.regionName;
    }
    return '';
};

export const normalizeOpportunityName = (name = '') => {
    return name === name.toUpperCase()
        ? name
              .toLowerCase()
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
        : name;
};
